export const ids = [
  {
    id: "509658",
    name: "Just Chatting",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/509658-65x65.jpg",
  },
  {
    id: "32982",
    name: "Grand Theft Auto V",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/32982_IGDB-65x65.jpg",
  },
  {
    id: "511224",
    name: "Apex Legends",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/511224-65x65.jpg",
  },
  {
    id: "27471",
    name: "Minecraft",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/27471_IGDB-65x65.jpg",
  },
  {
    id: "21779",
    name: "League of Legends",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/21779-65x65.jpg",
  },
  {
    id: "516575",
    name: "VALORANT",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/516575-65x65.jpg",
  },
  {
    id: "1158884259",
    name: "Splatoon 3",
    box_art_url:
      "https://static-cdn.jtvnw.net/ttv-boxart/1158884259_IGDB-65x65.jpg",
  },
  {
    id: "862021340",
    name: "Madden NFL 23",
    box_art_url:
      "https://static-cdn.jtvnw.net/ttv-boxart/862021340_IGDB-65x65.jpg",
  },
  {
    id: "33214",
    name: "Fortnite",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/33214-65x65.jpg",
  },
  {
    id: "18122",
    name: "World of Warcraft",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/18122-65x65.jpg",
  },
  {
    id: "512710",
    name: "Call of Duty: Warzone",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/512710-65x65.jpg",
  },
  {
    id: "32399",
    name: "Counter-Strike: Global Offensive",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/32399_IGDB-65x65.jpg",
  },
  {
    id: "29595",
    name: "Dota 2",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/29595-65x65.jpg",
  },
  {
    id: "491487",
    name: "Dead by Daylight",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/491487-65x65.jpg",
  },
  {
    id: "491931",
    name: "Escape from Tarkov",
    box_art_url:
      "https://static-cdn.jtvnw.net/ttv-boxart/491931_IGDB-65x65.jpg",
  },
  {
    id: "29452",
    name: "Virtual Casino",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/29452_IGDB-65x65.jpg",
  },
  {
    id: "26936",
    name: "Music",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/26936-65x65.jpg",
  },
  {
    id: "488190",
    name: "Poker",
    box_art_url: "https://static-cdn.jtvnw.net/ttv-boxart/488190-65x65.jpg",
  },
  {
    id: "516173984",
    name: "Cult of the Lamb",
    box_art_url:
      "https://static-cdn.jtvnw.net/ttv-boxart/516173984_IGDB-65x65.jpg",
  },
  {
    id: "411940336",
    name: "The Higher Lower Game",
    box_art_url:
      "https://static-cdn.jtvnw.net/ttv-boxart/411940336_IGDB-65x65.jpg",
  },
];
